<div>
  <button mat-raised-button type="button" (click)="add()">
    {{ to?.['addText'] ? to?.['addText'] : 'Add' }}
  </button>
</div>
<div *ngFor="let f of field.fieldGroup; let i = index;" [fxLayout]="to?.['fxLayout'] ? to?.['fxLayout'] : 'row wrap'"
  [fxLayoutGap]="to?.['fxLayoutGap']?to?.['fxLayoutGap']:'0px'">
  <formly-field [field]="f" [fxFlex]="f.props?.['fxFlex']">
  </formly-field>
  <div>
    <button [fxFlex]="to?.['removefxFlex']" mat-raised-button (click)="remove(i)">
      {{ to?.['removeText'] ? to?.['removeText'] : 'Remove' }}
    </button>
  </div>
</div>
